export const getProgrammeName = (name?: string) => {
  if (!name) {
    return 'Untitled Programme';
  }

  return name;
};
